var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('success',{attrs:{"title":"已发起询价","btn-list":_vm.btnData,"show-middle-close-btn":true}},[_c('p',{staticClass:"result_tips"},[_vm._v("询价"+_vm._s(_vm.inquiryTime[this.dataObj.period_type])+"，将在"+_vm._s(this.dataObj.finished_at)+"结束询价")])])}
var staticRenderFns = []

export { render, staticRenderFns }